define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/AggregateController",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,_,AggregateController,locale,MessageDialog,xml) {

	return declare(AggregateController, {
	
		/**
		 * @override
		 *
		 * Warn if there is no size range on the Product there will not be any available size curves. 
		*/
		_preAction: function() {
			const ctx = this.getContext();
			const poProduct = ctx.cache.getNode(this.getNode().POProduct);
			if(!xml.isValidURL(poProduct.SizeRange)){
				this.displayErrorDialog({
					materialIcon: MessageDialog.ICON_WARNING,
					message: locale.resource("OrderNoSizeRange_Error"),
					title: locale.resource("WARNING")
				});
			}else{
				return this.inherited(arguments);
			}
		},
		
		/**
		 * @override
		 *
		 * Confirm action of changing SizeCurve if order shipments have PackListItems
		*/
		hasToConfirmAction: function() {
			const order = this.getNode();
			if (order.Shipments.length == 0) {
				return false;
			}
			
			const ctx = this.getContext();
			return _.some(ctx.cache.getNodes(order.Shipments), function(shipment) {
				return shipment.PackListItems.length > 0;
			});
		},
		
		/**
		 * @override
		 *
		 * Show confirmation message and concatenate PackListItems
		*/
		confirmAction: function(params) {
			params = params || {};
			params.materialIcon = MessageDialog.ICON_WARNING;
			const packLists = [];
			const ctx = this.getContext();
			const order = this.getNode();
			_.each(ctx.cache.getNodes(order.Shipments), function(shipment) {
				_.each(ctx.cache.getNodes(shipment.PackListItems), function(packListItem) {
					packLists.push(ctx.cache.getNode(packListItem.__Parent__).$Name);
				});
			});
			
			const unique = (value, index, self) => {
				return self.indexOf(value) === index;
			}
			
			const uniquePackLists = packLists.filter(unique);
			
			params.title = locale.typeAction("OrderSizeCurveChange", "Title");
			params.message = locale.typeAction("OrderSizeCurveChange", "Message", [uniquePackLists.toString()]);
			params.buttons = [MessageDialog.BUTTON_OK, MessageDialog.BUTTON_CANCEL];
			this.inherited(arguments);
		},
		
		/**
		 * If configured to confirm action, then start now that confirmed
		 * @param {String} key - the button key hit by user
		 * @param {Object} values - hold the values from the MessageBox
		 * @param {Event} e
		 */
		onConfirm: function(key, values, e) {
			if (key == MessageDialog.BUTTON_OK) {
				this.preProcess();
			} else {
				this.postProcess();
			}
		}
	});
});